// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// Constants imports
import { URLConstants } from '../../../../_constants/url-constants';

// Model imports
import { ARMiscInvoiceEditorResultDto } from '../../_models/account-receivable/ar-misc-invoice/ar-misc-invoice-editor-result-dto';
import { ARMiscInvoiceSubcategoriesParameterDto } from '../../_models/account-receivable/ar-misc-invoice/ar-misc-invoice-subcategories-parameter-dto';
import { MiscInvoiceGLSubCategoryResultDto } from '../../_models/account-receivable/ar-misc-invoice/misc-invoice-gl-subcategory-result-dto';
import { ARMiscInvoicePaymentExistsParameterDto } from '../../_models/account-receivable/ar-misc-invoice/ar-misc-invoice-payment-exists-parameter-dto';
import { ARPostMiscInvoiceParametersDto } from '../../_models/account-receivable/ar-misc-invoice/ar-post-misc-invoice-parameters-dto';

@Injectable({
    providedIn: 'root'
})
export class ARMiscInvoiceService {
    constructor(private readonly httpClient: HttpClient) {}

    getARMiscInvoiceEditor(cId: number, mcId: number): Observable<ARMiscInvoiceEditorResultDto> {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc/editor?communityId=${cId}&managementCompanyId=${mcId}`;
        return this.httpClient
            .get<ARMiscInvoiceEditorResultDto>(url)
            .pipe(
                map((response: ARMiscInvoiceEditorResultDto) => plainToClass(ARMiscInvoiceEditorResultDto, response))
            );
    }

    getARMiscInvoiceSubcategories(
        param: ARMiscInvoiceSubcategoriesParameterDto
    ): Observable<MiscInvoiceGLSubCategoryResultDto> {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc/subcategories${param.getQueryString()}`;
        return this.httpClient
            .get<MiscInvoiceGLSubCategoryResultDto>(url)
            .pipe(
                map((response: MiscInvoiceGLSubCategoryResultDto) =>
                    plainToClass(MiscInvoiceGLSubCategoryResultDto, response)
                )
            );
    }

    validateMiscInvoicePayment(param: ARMiscInvoicePaymentExistsParameterDto): Observable<any> {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc/payment/validate`;
        return this.httpClient.post(url, classToPlain(param));
    }

    createARMiscInvoice(param: ARPostMiscInvoiceParametersDto): Observable<any> {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc`;
        return this.httpClient.post(url, classToPlain(param));
    }
}
